import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  eventInfoCardWrapper: {
    scrollSnapAlign: 'start',
    width: '100%',
    height: '77vh',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',

    '&.withHash': {
      '& .timePreview, & .eventTitle, & .status': {
        cursor: 'pointer',
      },
    },

    '& .scrollArrow': {
      position: 'absolute',
      bottom: 0,
      right: 0,
    },
  },

  eventInfoCard: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    gap: '32px',
    position: 'relative',

    '@media screen and (min-width: 1441px)': {
      padding: '16px',
      gap: '46px',
    },
  },

  timelineTools: {
    display: 'flex',
    position: 'absolute',
    transform: 'translate(0,-100%)',
    right: 0,
    top: -6,
    gap: '6px',

    '& .extraTools': {
      position: 'absolute',
      right: 0,
      display: 'flex',
      transform: 'translateY(-100%)',
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: 'auto',
      gap: '6px',
      top: '-16px',

      '@media screen and (min-width: 1441px)': {
        gap: '8px',
        top: '-20px',
      },
    },

    '@media screen and (min-width: 1441px)': {
      top: -8,
      gap: '8px',
    },
  },
}));

export default useStyles;
